import api from './api';
import {CHANNELS_SET_ACTIVE} from './channels';
import {AUTH_LOG_OUT, authorizeToken} from './auth';

export const USER_SET_PROFILE = 'USER_SET_PROFILE';
export const USER_SET_OAUTH = 'USER_SET_OAUTH';
export const USER_REMOVE_OAUTH = 'USER_REMOVE_OAUTH';

export const USER_FETCH_ORDERS = 'USER_FETCH_ORDERS';
export const USER_SET_ORDERS = 'USER_SET_ORDERS';
export const USER_ERROR_ORDERS = 'USER_ERROR_ORDERS';

const ORDERS_LIMIT = 10;

const initialState = {
  profile: undefined,
  oauth: undefined,
  orders: undefined
};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case USER_SET_PROFILE:
      return {
        ...state,
        profile: payload && {
          ...payload,
          ...payload.customer,
          customer: undefined
        }
      };
    case USER_SET_OAUTH:
      return {
        ...state,
        oauth: payload
      };
    case USER_REMOVE_OAUTH:
      return {
        ...state,
        oauth: state.oauth.filter(it => it.id !== payload)
      };
    case USER_FETCH_ORDERS:
      return {
        ...state,
        orders: {
          ...(state.orders || {total: -1, loaded: 0, items: []}),
          isLoading: true,
          error: false,
          page: payload.page
        }
      };
    case USER_SET_ORDERS:
      return {
        ...state,
        orders: {
          ...state.orders,
          isLoading: false,
          error: false,
          page: payload.page,
          total: payload.total,
          loaded: state.orders.loaded + payload.items.length,
          items: state.orders.items.concat(payload.items)
        }
      };
    case USER_ERROR_ORDERS:
      return {
        ...state,
        orders: {
          ...state.orders,
          isLoading: false,
          error: true,
          page: Math.min(1, payload.page - 1)
        }
      };
    case CHANNELS_SET_ACTIVE:
      return {
        ...state,
        orders: undefined
      };
    case AUTH_LOG_OUT:
      return initialState;
    default:
      return state;
  }
}

export function setUserProfile(profile) {
  return {type: USER_SET_PROFILE, payload: profile};
}

export function setUserOAuth(oAuth) {
  return {type: USER_SET_OAUTH, payload: oAuth};
}

export function fetchUserProfile() {
  return dispatch => {
    dispatch(setUserProfile(null));

    return dispatch(api.get('users/me/profile'))
      .then(profileResponse => dispatch(setUserProfile(profileResponse.content)));
  }
}

export function fetchUserOAuth() {
  return dispatch => {
    dispatch(setUserOAuth(null));

    return dispatch(api.getAll('users/me/oauth/accounts'))
      .then(oAuthResponse => dispatch(setUserOAuth(oAuthResponse.content.items)));
  }
}

export function fetchUserOrders(page = 1) {
  return dispatch => {
    dispatch({type: USER_FETCH_ORDERS, payload: {page}});

    return dispatch(api.get('users/me/orders', {page, limit: ORDERS_LIMIT}))
      .then(ordersResponse => dispatch({
        type: USER_SET_ORDERS,
        payload: {
          page,
          total: ordersResponse.meta.total,
          items: ordersResponse.content.items
        }
      }))
      .catch(err => dispatch({
        type: USER_ERROR_ORDERS,
        payload: {page}
      }));
  }
}

export function updateUserProfile({username, skypeUsername, discordUsername, tosAccepted, newsletterSubscribed}, avatar) {
  return dispatch => dispatch(api.post('users/me/profile', {
    user: {username},
    avatar: {file: avatar},
    skypeUsername: skypeUsername || '',
    discordUsername: discordUsername || '',
    phoneNumber: '',
    tosAccepted: tosAccepted ? '1' : undefined,
    newsletterSubscribed: newsletterSubscribed ? '1' : undefined,
  }))
    .then(profileResponse => dispatch(setUserProfile(profileResponse.content)));
}

export function updateUserPassword(currentPassword, newPassword) {
  return dispatch => dispatch(api.post('users/me/password', {
    password: currentPassword,
    user: {plainPassword: newPassword}
  }))
    .then(changePasswordResponse => dispatch(authorizeToken(changePasswordResponse.content.token)));
}

export function unlinkOAuth(id) {
  return dispatch => dispatch(api.delete(`users/me/oauth/accounts/by-id/${id}`))
    .then(() => dispatch({type: USER_REMOVE_OAUTH, payload: id}));
}

export function fetchUserCarts() {
  return dispatch => dispatch(api.getAll('users/me/carts'));
}



// WEBPACK FOOTER //
// ./ducks/user.js